module.exports = __webpack_public_path__ + "img/moa-tmb.a97c3b44.png";